export default __webpack_public_path__ + "static/media/starData2.ce212ec8.csv";